import { PageProjectCreate } from "@components/modules/projects/create/PageProjectCreate";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationProjects } from "@src/components/widgets/AppSubNav";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    title={t`Create project template`}
    navigation={<NavigationProjects />}
  >
    <PageProjectCreate />
  </MainLayout>
);

export const Route = createFileRoute("/projects/create-template")({
  component: Page,
});
